import RankingClientes from './RankingClientes'

export default function RankingCompradores() {
  return <RankingClientes tipo="compradores" titulo="Ranking de Compradores" tituloRelatorio="RELAÇÃO DE COMPRADORES" />
}
